import { authedGet } from "./api";
import { api_v3_list_of_players_by_playerIds } from "../utils/constants";

export const getPlayers = async (playerIds, token) => {
  const url = api_v3_list_of_players_by_playerIds(playerIds);
  return authedGet(url, token);
};
